@import '~style-sheet-helpers/core.less';
@import '../../../../app-brand/entities/entity-layer.module.less';
@import '../../../../constants/spacing.module.less';

.read-only {
  background: var(--grey-100);
  border-radius: 4px;
  padding: 8px;

  &:not(:last-child) {
    margin-bottom: 8px;
  }

  .row {
    align-items: flex-start;
  }
}

.half-row-item {
  width: 100%;
}

.declaration-header-wrapper {
  margin: @space-16 0;
  justify-content: space-between;
  align-items: center;
}

.declaration-wrapper {
  border-bottom: 1px solid var(--gray-DFE4E8);
  padding-bottom: @space-16;
}
